<script>
import cn from 'classnames';
import { ColorTypes } from '@/constants/enums';
export default {
  name: 'Headline',
  props: {
    heading: {
      type: Number,
      default: 2,
      validator: (val) => [1, 2, 3, 4, 5, 6].includes(val),
    },
    size: {
      type: String,
      default: 'xl',
      validator: (val) => ['xs', 's', 'm', 'l', 'xl', 'xxl'].includes(val),
    },
    color: {
      type: String,
      default: 'primaryBlue',
      validator: (val) => ColorTypes.includes(val),
    },
    isViewHeadline: Boolean,
    centered: Boolean,
    verticalCentered: Boolean,
    noMargin: Boolean,
    bordered: Boolean,
    responsive: Boolean,
    isSubheading: Boolean,
    staticClass: String,
  },
  data() {
    return {
      el: 'o-headline',
      classes: () => {
        const el = this.el;
        return cn({
          [el]: true,
          [`${el}--${this.heading}`]: true,
          [`${el}--${this.size}`]: true,
          [`${el}--${this.color}`]: this.color,
          [`${el}--centered`]: this.centered,
          [`${el}--verticalCentered`]: this.verticalCentered,
          [`${el}--responsive`]: this.responsive,
          [`${el}--noMargin`]: this.noMargin,
          [`${el}--bordered`]: this.bordered,
          [`${el}--isViewHeadline`]: this.isViewHeadline,
          [`${el}--isSubheading`]: this.isSubheading,
          [`${this.staticClass}`]: this.staticClass,
        });
      },
    };
  },
  render(createElement) {
    return createElement(
      `h${this.heading}`,
      {
        attrs: { class: this.classes() },
      },
      this.$slots.default
    );
  },
};
</script>
